<template>
  <div class="promotion_product" ref="container">
	<div class="promoter-header">
		<div class="promoter-search">
			<form @submit.prevent="submitForm()">
				<span @click="submitForm()" class="iconfont icon-sousuo sousuo"></span>
				<input placeholder="搜索" v-model="whereli.keyword" />
			</form>
		</div>
		<ul class="header-box">
			<li
			  v-for="(hitem,hindex) in headerList" 
			  :key="hindex" 
			  @click="hselected(hindex)"
			  :class="ishred == hindex ? 'on' : ''"
			>
			  {{ hitem }}
			</li>
			<i v-if="!isArrowShow" class="iconfont icon-youjian arrow-top font-color-orange"></i>
			<i v-if="isArrowShow" class="iconfont icon-youjian arrow-top"></i>
			<i v-if="isArrowShow" class="iconfont icon-youjian arrow-bottom font-color-orange"></i>
			<i v-if="!isArrowShow" class="iconfont icon-youjian arrow-bottom"></i>
		</ul>
		<!-- <ul v-if="isFirstShow" class="header-box">
			<li v-for="(item,key) in marketList" :key="key" @click="selected(key)">
				<span :class="isred == key ? 'on' : ''">{{ item }}</span>
			</li>
		</ul> -->
	</div>
	<ul v-if="productList.length > 0" class="promotion-product-list">
		<li v-for="(item,key) in productList" :key="key">
			<div class="product-list-top" @click="$router.push('/detail/'+item.id)">
				<div class="product-list-l"><img :src="item.image" alt=""></div>
				<div class="product-list-r">
					<p>{{ item.store_name }}</p>
					<p>
						￥<strong>{{ item.price }}</strong>
						<span class="ot-price">￥{{ item.ot_price }}</span>
					</p>
					<p class="font-color-orange">佣金比例{{ item.ratio }}%</p>
				</div>
			</div>
			<div class="product-list-right" @click="$router.push('/detail/'+item.id)">
				<i class="iconfont icon-chongzhi"></i> 预计赚￥{{ item.priceName ? item.priceName : '0' }}
			</div>
		</li>
	</ul>
	<div v-else class="no-product">暂无商品</div>
	<Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getSpreadGoods } from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "PromotionProduct",
  components: {
	  Loading
  },
  props: {},
  data: function() {
    return {
      // isFirstShow:true,
	  isArrowShow:true,
	  headerList:["佣金","最新","销量","价格"],
	  // marketList:["全部","拼团","限时折扣","秒杀","砍价"],
	  // isred:0,
	  ishred:0,
	  loaded: false,
	  loading: false,
	  whereli: {
	    page: 1,
	    limit: 15,
		type: "price",
		order: "desc",
		keyword:""
	  },
	  productList:[]
    };
  },
  watch: {
    $route(n) {
      if(n.name == 'PromotionProduct'){
		this.whereli.keyword = "";
		this.getProduct();
	  }
    }
  },
  mounted: function() {
	this.getProduct();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getProduct();
    });
  },
  methods: {
	getProduct(){
		let there = this;
		if (there.loaded == true || there.loading == true) return;
		there.loading = true;
		getSpreadGoods(there.whereli).then(
		  res => {
		    there.loading = false;
		    there.loaded = res.data.length < there.whereli.limit;
		    there.whereli.page = there.whereli.page + 1;
		    there.productList.push.apply(there.productList, res.data);
		  },
		  error => {
		    there.$dialog.message(error.msg);
			setTimeout(function(){
				there.$router.push('/');  
			},1000);
		  },
		  300
		);
	},
	submitForm(){
		this.whereli.type = "price";
		this.whereli.order = "desc";
		this.whereli.page = 1;
		this.loaded = false;
		this.loading = false;
		this.productList = [];
		this.getProduct();
	},
    hselected(key){
		this.ishred = key;
		// if(key == 0){
		// 	this.isFirstShow = true;
		// }else{
		// 	this.isFirstShow = false;
		// }
		if(key == 0){
			this.whereli.type = "price";
			this.whereli.order = "desc";
			this.whereli.page = 1;
			this.loaded = false;
			this.loading = false;
			this.productList = [];
		}
		if(key == 1){
			this.whereli.type = "new";
			this.whereli.order = "desc";
			this.whereli.page = 1;
			this.loaded = false;
			this.loading = false;
			this.productList = [];
		}
		if(key == 2){
			this.whereli.type = "sales";
			this.whereli.order = "desc";
			this.whereli.page = 1;
			this.loaded = false;
			this.loading = false;
			this.productList = [];
		}
		if(key == 3){
			this.whereli.type = "price";
			this.isArrowShow = !this.isArrowShow;
			if(this.isArrowShow){
				this.whereli.order = "desc";
			}else{
				this.whereli.order = "asc";
			}
			this.whereli.page = 1;
			this.loaded = false;
			this.loading = false;
			this.productList = [];
		}
		this.getProduct();
	},
	// selected(key){
	// 	this.isred = key;
	// },
	
  }
};
</script>
<style scoped>
.promoter-header{background-color: #fff;padding: 0.2rem 0 0 0;box-shadow: 0 0 5px #ddd;}
.promoter-search{background-color: #f7f8fa;border-radius: 17px;padding: 0.1rem 0;font-size: 0.28rem;text-indent: 1em;width: 95%;margin: 0 auto;margin-bottom: 0.2rem;}
.promoter-search input{text-indent: 0.5em;width: 90%;}
.sousuo{font-size: 0.28rem;}
ul.header-box{display: flex;justify-content: space-around;padding: 0.2rem 0;border-top: 1px solid #eee;position: relative;}
ul.header-box li span{padding: 0 0.2rem;border-radius: 17px;background-color: #f7f8fa;color: #777;display: inline-block;height: 0.45rem;line-height: 0.45rem;font-size: 0.26rem;}
.icon-youjian{font-size: 0.2rem;display: inline-block;position: absolute;color: #ddd;}
.arrow-top{transform:rotate(-90deg);top: 0.2rem;right: 0.23rem;}
.arrow-bottom{transform:rotate(90deg);top: 0.35rem;right: 0.25rem;}
li.on{color: #fd7226;}
ul.header-box li span.on{background-color: #fff0e7;color: #fd7226;}
.promotion-product-list{padding: 0 0.2rem 0.2rem 0.2rem;}
.promotion-product-list li{background-color: #fff;margin-top: 0.2rem;border-radius: 5px;padding: 0.2rem;overflow: hidden;}
.product-list-top{display: flex;justify-content: space-between;}
.product-list-l{width: 30%;}
.product-list-l img{width: 100%;border-radius: 5px;}
.product-list-r{width: 67%;}
.product-list-r p{margin-top: 0.3rem;}
.product-list-r p:first-child{margin-top: 0;}
.product-list-r p strong{font-size: 0.36rem;}
.product-list-r .ot-price{color: #999;text-decoration: line-through;margin-left: 0.2rem;font-size: 0.26rem;}
.font-color-orange{color: #fd7226;}
.product-list-right{float: right;padding: 0.1rem 0.2rem;background-color: #fd902e;color: #fff;border-radius: 17px;margin-top: 0.1rem;}
.icon-chongzhi{font-size: 0.3rem;}
.no-product{text-align: center;color: #999;font-size: 0.26rem;margin-top: 0.2rem;}
</style>
